import { Page, View, Text, Link, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  Portfolio,
  PublicEventDetailsResponse,
} from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export interface KeyTopicsPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const KeyTopicsPage = ({ event, footer }: KeyTopicsPageProps) => {
  const { t, i18n } = useTranslation();

  const eventKeyTopicsItems = useMemo(
    () =>
      event?.website_content?.keytopics
        ?.filter(e => e.published)
        .sort((a, b) => a.order - b.order)
        ?.map(keyTopic => ({
          title: keyTopic.title,
          subtitle: keyTopic.description,
          order: keyTopic.order,
        })),
    [event?.website_content?.keytopics]
  );

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.leftColumn,
        }}
      >
        <Text style={{ ...styles.title }}>{t('key-topics-to-talk-about')}</Text>

        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
            marginLeft: 0,
          }}
        />

        <Text style={styles.keyTopicsListTitle}>
          {i18n?.language === 'de' ? 'Zu' : 'At'} {event?.name}
        </Text>

        <View style={styles.keyTopicsListWrapper}>
          {eventKeyTopicsItems?.map((keytopicItem, index) => {
            return (
              <View key={index} style={styles.keyTopicsListItemWrapper}>
                <Text style={{ ...styles.keyTopicsText, marginRight: 4 }}>
                  •
                </Text>
                <Text style={styles.keyTopicsText}>
                  {keytopicItem?.title} {keytopicItem?.subtitle}
                </Text>
              </View>
            );
          })}
        </View>
      </View>

      <View style={styles.rightColumn}>
        <View style={styles.imageSection}>
          <View style={styles.leftImageColumn}>
            <Image
              src="https://media.we-conect.com/images/pdf/partnerprospectus/8_1.png"
              style={styles.leftTopImage}
            />
            <View style={styles.smallImageSpacer} />
            <Image
              src="https://media.we-conect.com/images/pdf/partnerprospectus/8_3.png"
              style={styles.leftBottomImage}
            />
          </View>

          <View style={styles.rightImageColumn}>
            <Image
              src="https://media.we-conect.com/images/pdf/partnerprospectus/8_2.png"
              style={styles.rightTopImage}
            />
            <View style={styles.smallImageSpacer} />
            <Image
              src="https://media.we-conect.com/images/pdf/partnerprospectus/8_4.png"
              style={styles.rightBottomImage}
            />
          </View>
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default KeyTopicsPage;
